<app-loader *ngIf="loading"></app-loader>
<div class="public-page pick-page">
    <div class="public-container public-container_transparent">
        <div [formGroup]="form">
            <div class="public-page-h1 public-page-h1_text-align_center">
                <ng-container
                        *ngIf="pageType === 'TAN' || (pageType === 'TANPAN' && !needToCreateToken); else createTokenHeader">
                    Завершите привязку карты
                </ng-container>
                <ng-template #createTokenHeader>
                    Привяжите карту к платежному приложению
                </ng-template>
            </div>

            <ng-container *ngIf="pageType === 'PAN' || pageType === 'TANPAN'">
                <!-- Заголовок карты и описание -->
                <div class="text-block text-block_text-align_center text-block_margin-bottom_24">
                    <div class="text-block__simple-text" *ngIf="pageType === 'PAN'">
                        Для завершения привязки социальной карты подтвердите карту, которая будет использована для
                        получения льгот
                    </div>
                    <div class="text-block__simple-text" *ngIf="pageType === 'TANPAN' && !needToCreateToken">
                        Для завершения привязки социальной карты подтвердите карту или устройство, которое будет
                        использовано для получения
                        льгот
                    </div>
                    <div class="text-block__h4 text-block__h4_margin-bottom_0">Ваша карта &laquo;Мир&raquo;</div>
                </div>

                <!-- Карта -->
                <div class="radio-buttons-block">
                    <div class="radio-buttons-block__item radio-buttons-block__item_justify-content_center">
                        <div class="for-radio-btn">
                            <div *ngIf="pageType === 'TANPAN' && card?.tokens?.length; else panLabel">
                                <p-radioButton
                                        [value]="card.id"
                                        name="cardId"
                                        formControlName="cardId"
                                        [inputId]="card.id"
                                ></p-radioButton>
                                <label class="p-radiobutton-label" [for]="card.id">{{'**** ' + card.last4}}</label>
                            </div>
                            <ng-template #panLabel>
                                <div class="p-radiobutton-label pick-page__temporary-card-label">
                                    **** {{ card?.last4 }}</div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="pageType === 'TAN' || pageType === 'TANPAN'">
                <div class="text-block text-block_text-align_center text-block_margin-bottom_32">
                    <div *ngIf="pageType === 'TAN'"
                         class="text-block__h4 text-block__h4_margin-bottom_16"
                    >
                        Ваша карта &laquo;Мир&raquo; <span class="pick-page__card-number">**** {{ card?.last4 }}</span>
                    </div>
                    <ng-container *ngIf="pageType === 'TAN'">
                        <div class="text-block__simple-text text-block__simple-text_margin-bottom_0"
                             *ngIf="card?.tokens?.length; else noTokenList"
                        >
                            Для завершения привязки социальной карты подтвердите устройство, которое будет использовано
                            для получения льгот.
                        </div>
                        <ng-template #noTokenList>
                            <div class="text-block__simple-text">
                                Откройте приложение MirPay и привяжите к нему карту. Затем вернитесь в это окно и
                                нажмите на кнопку &laquo;Я
                                привязал карту&raquo;.
                            </div>
                        </ng-template>
                    </ng-container>
                    <ng-container *ngIf="pageType === 'TANPAN' && !card?.tokens?.length">
                        <div class="text-block__simple-text text-block__simple-text_margin-bottom_0">
                            <div class="text-block__simple-text">
                                <ng-container *ngIf="!needToCreateToken; else createTokenText">
                                    Вы можете привязать вашу карту к мобильному устройству и приложению MirPay<br>
                                    <a (click)="needToCreateToken = true">Привязать карту к MirPay</a>
                                </ng-container>
                                <ng-template #createTokenText>
                                    Откройте приложение MirPay и привяжите к нему карту.<br>
                                    Затем вернитесь в это окно и нажмите кнопку &laquo;Я привязал карту&raquo;
                                </ng-template>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <ng-container *ngIf="card?.tokens?.length; else updateTokenListBlock">
                    <!-- Заголовок списка токенов -->
                    <div class="text-block text-block_text-align_center text-block_margin-bottom_24">
                        <div class="text-block__h4 text-block__h4_margin-bottom_0">
                            Карта привязана в приложении MirPay на следующих устройствах:
                        </div>
                    </div>

                    <!-- Список токенов -->
                    <div class="radio-buttons-block">
                        <div class="radio-buttons-block__item" *ngFor="let token of card.tokens">
                            <div class="for-radio-btn">
                                <div *ngIf="pageType === 'TANPAN' || (pageType === 'TAN' && card.tokens.length > 1); else noRadioButton">
                                    <p-radioButton
                                            [value]="token.id"
                                            name="cardId"
                                            formControlName="cardId"
                                            [inputId]="token.id"
                                    ></p-radioButton>
                                    <label class="p-radiobutton-label" [for]="token.id">{{token.walletProgramData + ' **** ' + token.last4}}</label>
                                </div>
                                <ng-template #noRadioButton>
                                    <label class="p-radiobutton-label">
                                        {{ token.walletProgramData + ' **** ' + token.last4 }}
                                    </label>
                                </ng-template>
                            </div>
                            <span class="radio-buttons-block__question-mark"
                                  [escape]="false"
                                  tooltipStyleClass="p-tooltip_max-width_300"
                                  [pTooltip]="isMobile ? null : tooltipText"
                                  tooltipPosition="right"
                                  (click)="showInfoModal()"
                            >?</span>
                        </div>
                    </div>
                </ng-container>

                <ng-template #updateTokenListBlock>
                    <div class="row p-grid" *ngIf="pageType === 'TAN' || (pageType === 'TANPAN' && needToCreateToken)">
                        <div class="col p-col-12 p-md-6 p-md-offset-3">
                            <!-- Информация о том, как сформировать токен -->
                            <div class="text-block text-block_text-align_center text-block_margin-bottom_0">
                                <div class="text-block__h4 text-block__h4_margin-bottom_24">Узнайте, как привязать
                                    карту:
                                </div>
                                <div class="text-block__h4">
                                    <a (click)="redirectToInstruction()">Mir Pay</a>
                                </div>
                            </div>
                            <div class="for-btn for-btn_text-align_center pick-page__for-btn pick-page__for-btn_width_200">
                                <button class="for-btn__button"
                                        [ngClass]="{'for-btn__button_margin-bottom_24': !needToCreateToken}"
                                        pButton
                                        label="Я привязал карту"
                                        (click)="updateCardInfo()"></button>
                            </div>
                            <div *ngIf="pageType === 'TANPAN' && needToCreateToken"
                                 class="for-btn for-btn_text-align_center pick-page__for-btn pick-page__for-btn_margin-top_20 pick-page__for-btn_width_200">
                                <button class="for-btn__button for-btn__button_transparent"
                                        pButton
                                        label="Вернуться"
                                        (click)="needToCreateToken = false"
                                ></button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container>

            <!-- Кнопка "Подтвердить" -->
            <div class="for-btn for-btn_text-align_center pick-page__for-btn"
                 *ngIf="pageType === 'PAN' || (pageType === 'TAN' && card?.tokens?.length) || (pageType === 'TANPAN' && !needToCreateToken)"
            >
                <button class="for-btn__button"
                        pButton
                        label="Подтвердить"
                        (click)="submitForm()"
                ></button>
            </div>
        </div>
    </div>
</div>
